import PubSub from "underpub-js";

var NavBar = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-NavBar',
	};

	$.extend(true, this.options, options);

};

NavBar.prototype.init = function() {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__menuButton`).on('click', function() {

		PubSub.publish('NavOverlay:show');

	});

	this.options.$el.find(`.${self.options.baseClass}__search`).on('click', function() {

		PubSub.publish('NavOverlay:showSearch');

	});

};

export default NavBar;
